import { NgClass } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormsModule, ReactiveFormsModule, UntypedFormControl, Validators } from '@angular/forms';
import { MatOptionModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FormSelectItem } from 'src/app/model/form/select-item.model';
import { Destroyed } from 'src/app/utils/directives/destroyed.directive';
import { isNotNullOrUndefined, isNullOrUndefined } from 'src/app/utils/utils.static';

@Component({
    selector: 'app-select-multiple',
    templateUrl: './select-multiple.component.html',
    styleUrls: ['./select-multiple.component.scss'],
    imports: [
        FormsModule,
        ReactiveFormsModule,
        NgClass,
        MatSelectModule,
        MatTooltipModule,
        MatOptionModule
    ]
})
export class SelectMultipleComponent extends Destroyed implements OnInit {
    @Input() group;
    @Input() fcName: string;
    @Input() items: Array<FormSelectItem>;
    @Input() textLabel: string;

    @Input() error = false;
    @Input() errorMsg: string;

    @Input() i = 0; // i si l'input est dans une boucle (pour éviter d'avoir 2 composants ayant le même id
    @Input() disabled: boolean;
    @Input() required = false;
    @Input() displayAllSelected = false;

    @Output() modelAttributeChange = new EventEmitter();

    placeholder: string;

    public control = new UntypedFormControl([{ value: [], disabled: false }, Validators.required]);
    public formatedControlValue: string;
    public tooltipFormatted: string;

    constructor() {
        super();
    }

    ngOnInit() {
        this.control = this.group.get(this.fcName);
        this.formatedControlValue = this.formatDisplay();
        this.tooltipFormatted = this.formatTooltip();

        this.control.valueChanges.pipe(this.untilDestroyed()).subscribe((val) => this.change(val));

        if (this.items && this.items.length > 0) {
            this.placeholder = 'Choisir un élément';
        } else {
            this.placeholder = 'Aucun élément';
        }
    }

    change(newValue) {
        this.formatedControlValue = this.formatDisplay();
        this.tooltipFormatted = this.formatTooltip();
        this.modelAttributeChange.emit(newValue);
    }

    formatDisplay() {
        const selectedIds: (number | string | null | undefined)[] = this.control.value ?? [];

        const getItemName = (id: number | string): string => {
            if (isNullOrUndefined(id) || Number(id) < 0) {
                return String(id);
            }
            return this.items.find((item) => item.id === Number(id))?.name ?? String(id);
        };

        if (selectedIds.length === 0) {
            return '';
        }

        // returns concatenated items.name
        if (this.displayAllSelected) {
            return selectedIds.map((id) => getItemName(id)).join(', ');
        }

        // returns first item.name
        if (selectedIds.length === 1) {
            return getItemName(selectedIds[0]);
        }

        // returns first item.name (+ x others)
        const firstName = getItemName(selectedIds[0]);
        const suffix = selectedIds.length === 2 ? 'autre' : 'autres';
        return `${firstName} (+${selectedIds.length - 1} ${suffix})`;
    }

    formatTooltip() {
        let value = '';
        if (
            this.group &&
            this.fcName &&
            this.group.get(this.fcName) &&
            isNotNullOrUndefined(this.control.value) &&
            this.control.value.length > 0
        ) {
            value = this.control.value
                .map((val) => this.items.find((item) => item.id === Number(val)).name)
                .join(', ');
        }

        return value;
    }
}
